import { siteLabel, type PublicApiScope, type Site, type SiteCreated, type SitePatch } from "@omnabase/shared";
import { api } from "./api";
import { useFetch } from "./inbox";

/** Settings › Integrations › API keys' data (M12 round one): the workspace's sites with a live key from `GET /w/:slug/sites`, and the
 *  writes. The key itself travels once, in the answer to the create; nothing here keeps it. */
export const sitesUrl = (slug: string) => `/api/v1/w/${slug}/sites`;
export function useSites(slug: string, enabled: boolean) {
  return useFetch<{ rows: Site[] }>(enabled ? sitesUrl(slug) : null);
}
/** the list as the Integrations page shares it between the WordPress card and the key table (M14 round three) */
export type SitesList = ReturnType<typeof useSites>;
export const sites = {
  create: (slug: string, body: { name: string; url: string | null; scopes: PublicApiScope[]; projects: string[] }) => api.post<SiteCreated>(sitesUrl(slug), body),
  revoke: (slug: string, id: string) => api.del<{ ok: true }>(`${sitesUrl(slug)}/${id}`),
  /** M14 round five: the site's option for public forum topics */
  patch: (slug: string, id: string, body: SitePatch) => api.patch<{ site: Site }>(`${sitesUrl(slug)}/${id}`, body),
};
/** a connected site's name on the WordPress card and in the Disconnect dialog: "host/folder" for a site in a subfolder, the host for a root
 *  site (DECISIONS "2026-10-11 — Sites in a subfolder"), the key's name when it has no address */
export const siteNameOf = (s: Pick<Site, "url" | "host" | "name">): string => (s.url ? siteLabel(s.url) : null) ?? s.host ?? s.name;
/** what the dialog still needs before "Create key" (null: ready) */
export function keyProblem(site: string, scopes: readonly string[]): string | null {
  if (!site.trim()) return "Name the site or script that uses the key.";
  if (!scopes.length) return "Pick at least one thing the key may do.";
  return null;
}
